import { Suspense } from 'react';
import { Navigate, Outlet, Route } from 'react-router';
import {
  AddTOTPPage,
  CallbackOIDC,
  LoginMFA,
  LoginOIDC,
  LoginPage,
  MagicLinkPage,
  RegisterMFA,
  RegisterWebAuthnPage,
} from '#route-bundles/unauthenticated.tsx';
import { HasUser } from '#screens/auth/HasUser.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { fromArray, Titled } from '#util/title.ts';

/**
 * {@link authRootRoute} contains all of the routing config for the /auth path
 */
export const authRootRoute = (
  <Route
    element={
      <Titled title={(title) => fromArray(['Auth', title])}>
        <Outlet />
      </Titled>
    }
  >
    <Route
      path="login"
      element={
        <Suspense fallback={<LoadingSpinner />}>
          <LoginPage />
        </Suspense>
      }
    />
    <Route path="login/:orgID" element={<LoginOIDC />} />
    <Route path="oidc-callback" element={<CallbackOIDC />} />
    <Route path="magic-link" element={<MagicLinkPage />} />
    <Route
      path="mfa"
      element={
        <HasUser>
          <Outlet />
        </HasUser>
      }
    >
      <Route path="register">
        <Route index={true} element={<RegisterMFA />} />
        <Route path="passkey" element={<RegisterWebAuthnPage />} />
        <Route path="totp" element={<AddTOTPPage />} />
      </Route>
      <Route path="renew?" element={<LoginMFA />} />
    </Route>
    <Route path="*" element={<Navigate to="/auth/login" replace={true} />} />
  </Route>
);
